export default {
  // breadcrumb label
  breadcrumbHomePage: {
    id: 'reviews_page_breadcrumb_home',
    defaultMessage: 'Home',
  },
  breadcrumbCurrentPage: {
    id: 'reviews_page_breadcrumb_current_page',
    defaultMessage: 'Reviews',
  },

  // back button label
  goBackSeller: {
    id: 'review_display_goback_seller',
    defaultMessage: 'Go back to the seller',
  },
  goBackDefault: {
    id: 'review_display_goback_default',
    defaultMessage: 'Home',
  },
} as const
